import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Icons as I } from '../components/pack-icons';
import { CHATGPT_APP_URL, CLAUDE_CODE_COMMAND, CLAUDE_INSTALL_URL, MCP_ENDPOINT_URL, writeMcpOnboardingChoice } from '../lib/connectors.js';
import { ChatGptMark, ClaudeMark, CopyChip, EducationStrip, MiniStepper } from './OnboardingMcpShared.jsx';

export default function OnboardingConnect() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [tab, setTab] = useState('claude');

  useEffect(() => { writeMcpOnboardingChoice('ai'); }, []);

  const connectClaude = () => {
    window.open(CLAUDE_INSTALL_URL, '_blank', 'noopener,noreferrer');
    navigate('/onboarding/say-hello');
  };
  // Dathent was approved into the ChatGPT app directory (2026-08-19), so this
  // pane now mirrors Claude's one-click shape instead of walking people through
  // Developer mode. The manual endpoint stays available in the collapsed block
  // below for Codex/IDE users and anyone who cannot find the listing.
  const connectChatGpt = () => {
    window.open(CHATGPT_APP_URL, '_blank', 'noopener,noreferrer');
    navigate('/onboarding/say-hello');
  };
  const useApp = (event) => {
    event.preventDefault();
    writeMcpOnboardingChoice('ui');
    navigate('/onboarding?setup=ui', { replace: true });
  };

  return (
    <main className="mcpo-stage">
      <div className="mcpo-column mcpo-connect-column">
        <section className="mcpo-panel mcpo-connect-panel">
          <MiniStepper active={1} />
          <h1>{t('mcpOnboarding.connectTitle')}</h1>
          <p className="mcpo-subtitle">{t('mcpOnboarding.connectSubtitle')}</p>
          <div className="mcpo-assistant-tabs" role="tablist">
            <button type="button" className={`mcpo-assistant-tab ${tab === 'claude' ? 'mcpo-is-on' : ''}`} role="tab" aria-selected={tab === 'claude'} onClick={() => setTab('claude')}><ClaudeMark size={15} />{t('settings.connectorClaudeTitle')}</button>
            <button type="button" className={`mcpo-assistant-tab ${tab === 'chatgpt' ? 'mcpo-is-on' : ''}`} role="tab" aria-selected={tab === 'chatgpt'} onClick={() => setTab('chatgpt')}><ChatGptMark size={15} />{t('settings.connectorChatgptTitle')}</button>
          </div>

          {tab === 'claude' ? (
            <div className="mcpo-pane" role="tabpanel">
              <div className="mcpo-claude-main">
                <span className="mcpo-claude-tile"><ClaudeMark size={26} /></span>
                <button type="button" className="mcpo-claude-button" onClick={connectClaude}>{t('settings.connectorClaudeInstall')} <I.external size={16} /></button>
                <p className="mcpo-pane-caption">{t('settings.connectorClaudeInstallDesc')}</p>
              </div>
              <details className="mcpo-code-details">
                <summary><I.command size={14} />{t('settings.connectorClaudeCodeTitle')} ({t('mcpOnboarding.terminal')})<I.chevDown className="mcpo-code-chevron" size={13} /></summary>
                <p className="mcpo-code-hint">{t('settings.connectorClaudeCodeHint')}</p>
                <div className="mcpo-command"><code>{CLAUDE_CODE_COMMAND}</code><CopyChip value={CLAUDE_CODE_COMMAND} /></div>
              </details>
            </div>
          ) : (
            <div className="mcpo-pane" role="tabpanel">
              <div className="mcpo-claude-main">
                <span className="mcpo-claude-tile"><ChatGptMark size={26} /></span>
                <button type="button" className="mcpo-claude-button" onClick={connectChatGpt}>{t('settings.connectorChatgptInstall', { defaultValue: 'Open in ChatGPT' })} <I.external size={16} /></button>
                <p className="mcpo-pane-caption">{t('settings.connectorChatgptInstallDesc', { defaultValue: 'Dathent is in the ChatGPT app directory — open it, press Connect, and sign in with your Dathent account.' })}</p>
              </div>
              <details className="mcpo-code-details">
                <summary><I.command size={14} />{t('settings.connectorChatgptManualTitle', { defaultValue: 'Add it manually instead' })}<I.chevDown className="mcpo-code-chevron" size={13} /></summary>
                <p className="mcpo-code-hint">{t('settings.connectorChatgptSteps')}</p>
                <div className="mcpo-command"><code>{MCP_ENDPOINT_URL}</code><CopyChip value={MCP_ENDPOINT_URL} /></div>
              </details>
            </div>
          )}
          <p className="mcpo-escape"><a href="/onboarding" onClick={useApp}>{t('mcpOnboarding.preferApp')}</a></p>
        </section>
        <EducationStrip compact />
      </div>
    </main>
  );
}
